/**
 * 검색 결과가 우리가 가진 그 책인지 판정한다.
 *
 * 카카오 1순위가 다른 판본일 수 있다. 『블리치』를 찾으면
 * 『블리치 리믹스 1』이 먼저 나온다 — 제목만 보면 통과해 버린다.
 * 그래서 저자까지 겹쳐야 같은 책으로 본다.
 */

const norm = (x) => (x || "").toLowerCase().replace(/[\s\-·:,.!?()[\]{}《》『』「」'"’”]/g, "");

/**
 * @param {{title:string, author:string}} book  우리가 가진 책
 * @param {Array<{title:string, authors?:string[], translators?:string[]}>} docs  검색 결과
 * @returns 같은 책으로 보이는 항목, 없으면 undefined
 */
export default function matchBook(book, docs) {
  const nt = norm(book.title);
  if (!nt) return undefined;

  const authorParts = (book.author || "")
    .split(/[,·]/)
    .map(norm)
    .filter((a) => a.length >= 2);

  return (docs || []).find((d) => {
    const dt = norm(d.title);
    // 부제나 "(리커버)" 가 붙는 경우가 많아 완전 일치는 요구하지 않는다
    if (!(dt.startsWith(nt) || nt.startsWith(dt))) return false;
    // 제목이 완전히 같으면 저자 표기가 달라도 같은 책이다.
    // 원서는 저자가 로마자("Amy C. Edmondson")와 한글로 갈린다.
    if (dt === nt) return true;
    if (!authorParts.length) return true;
    const da = norm([...(d.authors || []), ...(d.translators || [])].join(""));
    return authorParts.some((a) => da.includes(a));
  });
}
